"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareRegExps = void 0;
var regexps_1 = require("./regexps");
var prepareRegExps = function (inputRegExps) {
    var _a = inputRegExps.attachesRegExps, _b = _a === void 0 ? {} : _a, cloudAttachIdReg = _b.cloudAttachIdReg, temporaryAttachIdReg = _b.temporaryAttachIdReg, attachIdReg = _b.attachIdReg, cloudStockAttachIdReg = _b.cloudStockAttachIdReg, _c = inputRegExps.messageIdsRegExps, _d = _c === void 0 ? {} : _c, commonMessageIdReg = _d.commonMessageIdReg, temporaryMessageIdReg = _d.temporaryMessageIdReg, urlPartsReg = inputRegExps.urlPartsReg, attachPathReg = inputRegExps.attachPathReg, emlFormatId = inputRegExps.emlFormatId;
    var checkedAttachesRegExps = {
        cloudAttachIdReg: new RegExp(cloudAttachIdReg || regexps_1.CloudAttachIdReg),
        temporaryAttachIdReg: new RegExp(temporaryAttachIdReg || regexps_1.TemporaryAttachIdReg),
        attachIdReg: new RegExp(attachIdReg || regexps_1.AttachIdReg),
        cloudStockAttachIdReg: new RegExp(cloudStockAttachIdReg || regexps_1.CloudStockAttachIdReg),
    };
    var checkedMessageIdsRegExps = {
        commonMessageIdReg: new RegExp(commonMessageIdReg || regexps_1.CommonMessageIdReg),
        temporaryMessageIdReg: new RegExp(temporaryMessageIdReg || regexps_1.TemporaryAttachIdReg),
    };
    var checkedUrlPartsReg = new RegExp(urlPartsReg || regexps_1.URLPartsReg);
    var checkedAttachPathReg = new RegExp(attachPathReg || regexps_1.AttachPathReg);
    var checkedEmlFormatId = new RegExp(emlFormatId || regexps_1.EmlFormatId);
    return {
        attachesRegExps: checkedAttachesRegExps,
        messageIdsRegExps: checkedMessageIdsRegExps,
        urlPartsReg: checkedUrlPartsReg,
        attachPathReg: checkedAttachPathReg,
        emlFormatId: checkedEmlFormatId,
    };
};
exports.prepareRegExps = prepareRegExps;
//# sourceMappingURL=prepareRegExps.js.map